exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-217a0407],\n.fade-leave-active[data-v-217a0407] {\n\ttransition-duration: 0.3s;\n\ttransition-property: opacity;\n\ttransition-timing-function: ease;\n}\n.fade-enter[data-v-217a0407],\n.fade-leave-active[data-v-217a0407] {\n\topacity: 0;\n}\n#mainWrap[data-v-217a0407] {\n\tmax-width: 380px;\n}\n\n", ""]);

// exports
